import { render } from "./ChoiceListComponent.vue?vue&type=template&id=66f582fb"
import script from "./ChoiceListComponent.vue?vue&type=script&lang=js"
export * from "./ChoiceListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__